/* eslint-disable */
/**
 * Created by xsdlr on 2017/6/9.
 */
let _hmt = _hmt || []
export default function baidu () {
  let hm = document.createElement('script')
  hm.src = 'https://hm.baidu.com/hm.js?5e8ac372fa5c8e5b076d39a794674028'
  let s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(hm, s)
}




// WEBPACK FOOTER //
// ./src/baidu_gongda.js